export const appConfigFieldNames = {
  CurrentErpCodeFieldName: 'current_erp_code',
  ExpressOrdersEnabledToProfileTypeFieldName: 'express_orders_enabled_to_profile_type',
}